import { API_VERSION, PATH_AUTH_API, SSO_REGISTRATION_CONFIRM } from '../constants/api-routes';
import { baseSsoApi } from 'src/services/base.sso.api';
import { clearOnLogout } from 'src/utils/clear.util';

export const authSsoService = baseSsoApi.injectEndpoints({
  endpoints: (build) => ({
    registrationConfirm: build.mutation({
      query: ({ token }) => ({
        url: `${API_VERSION.V1}/${SSO_REGISTRATION_CONFIRM}`,
        method: 'POST',
        params: { ...(token !== '' && { token }) },
      }),
    }),
    token: build.mutation({
      query: ({ email, password }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.TOKEN}`,
        method: 'POST',
        body: { email, password },
        meta: { skipAuthRetry: true },
      }),
      transformResponse(baseQueryReturnValue, meta, arg) {
        localStorage.setItem('user', JSON.stringify(baseQueryReturnValue));
        return baseQueryReturnValue;
      },
    }),
    tokenGoogle: build.mutation({
      query: ({ token }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.TOKEN_GOOGLE}`,
        method: 'POST',
        body: { token },
      }),
      transformResponse(baseQueryReturnValue, meta, arg) {
        localStorage.setItem('user', JSON.stringify(baseQueryReturnValue));
        return baseQueryReturnValue;
      },
    }),
    logout: build.mutation({
      query: ({ refresh_token }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.LOGOUT}`,
        method: 'POST',
        body: {
          refresh_token,
        },
      }),
      transformResponse(baseQueryReturnValue, meta, arg) {
        clearOnLogout();
      },
    }),
    refreshToken: build.mutation({
      query: ({ refresh_token }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.TOKEN_REFRESH}`,
        method: 'POST',
        body: {
          refresh_token,
        },
      }),
    }),
    resetPasswordConfirm: build.mutation({
      query: ({ password, password2, token }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.RESET_PASSWORD_CONFIRM}`,
        method: 'POST',
        body: {
          password,
          password2,
        },
        params: { token },
      }),
    }),
    resetPassword: build.query({
      query: ({ email }) => ({
        url: `${API_VERSION.V1}/${PATH_AUTH_API.RESET_PASSWORD}`,
        params: {
          email: email,
        },
      }),
    }),
  }),
});

export const {
  useTokenMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useTokenGoogleMutation,
  useLazyResetPasswordQuery,
  useResetPasswordConfirmMutation,
  useRegistrationConfirmMutation,
} = authSsoService;
